export default "__VITE_ASSET__452c8410__"